// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__25LNL","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__8mdvx"};